import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/erroricon.svg'


const _hoisted_1 = { class: "errcontainer" }
const _hoisted_2 = { class: "errorinnerdiv" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "errortextdiv" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "imagestyle",
    alt: "erroriconimg",
    title: "erroriconimg"
  }),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("b", null, " Connection time out. ")
  ])
], -1)
const _hoisted_4 = { class: "timeoutdiv" }
const _hoisted_5 = { style: {"align-self":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_text, { class: "normalerrortext" }, {
          default: _withCtx(() => [
            _createTextVNode("Request timed out, login or refresh the page to continue the session.")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            id: "gotologin",
            round: "",
            class: "btnstyle",
            variant: "warning",
            onClick: _ctx.gotoLogin
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Go to Login")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}